module.exports = __webpack_public_path__ + "static/media/Blur-asset-2.0d6b0c3a.png";